import cx from "classnames";

import { Label } from "common/ui/Label";

import styles from "./UserIcon.module.scss";

interface Props {
  name: string,
  onClick?: () => void,
  className?: string,
}

export function UserIcon({
  name,
  onClick,
  className,
}: Props) {

  const getNameInitials = (name) => {
    if (!name) return '';
    const nameParts = name.trim().split(' ');
    const firstNameInitial = nameParts[0]?.charAt(0).toUpperCase() || '';
    const lastNameInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0).toUpperCase() : '';
    return `${firstNameInitial}${lastNameInitial}`;
  };

  return (
    <div
      className={cx(styles.UserIcon, className, {
        [styles.Clickable]: onClick !== undefined,
      })}
      onClick={onClick}
    >
      <Label variant="l1">
        {getNameInitials(name)}
      </Label>
    </div>
  )
}

